import React from "react";
import { NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";

// Two-layer guard, matching eventshouse-web: this layout handles "is anyone
// logged in at all", redirecting to /admin/login if not. Any page that needs
// a stricter check (e.g. super_admin-only) does that itself.
export default function AdminLayout() {
  const { currentAdmin, isLoading, logout } = useAdminAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-c-gray text-secondary-light">
        加载中…
      </div>
    );
  }

  if (!currentAdmin) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return (
    <div className="min-h-screen bg-[#f7f6f5] font-main-sans">
      <header className="sticky top-0 z-20 bg-secondary-dark/90 backdrop-blur-md text-white flex items-center justify-between px-6 py-3 shadow-md">
        <div className="flex items-center gap-6">
          <span className="font-semibold tracking-wide">NVFO 管理后台</span>
          <span className="w-px h-5 bg-white/20" />
          <nav className="flex items-center gap-1 text-sm">
            <NavLink
              to="/admin/programs"
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-full transition-colors ${
                  isActive ? "bg-white/10 text-gold" : "text-white/70 hover:text-gold-light"
                }`
              }
            >
              项目管理
            </NavLink>
            <NavLink
              to="/admin/articles"
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-full transition-colors ${
                  isActive ? "bg-white/10 text-gold" : "text-white/70 hover:text-gold-light"
                }`
              }
            >
              文章管理
            </NavLink>
            <NavLink
              to="/admin/leads"
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-full transition-colors ${
                  isActive ? "bg-white/10 text-gold" : "text-white/70 hover:text-gold-light"
                }`
              }
            >
              客户信息
            </NavLink>
          </nav>
        </div>
        <div className="flex items-center gap-4 text-sm text-white/70">
          <span>
            {currentAdmin.name} · {currentAdmin.role === "super_admin" ? "超级管理员" : "管理员"}
          </span>
          <button onClick={logout} className="text-gold-light hover:text-gold transition-colors">
            退出登录
          </button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
